module.exports = __webpack_public_path__ + "static/img/icon_qtb.b5bb0778.png";